var _excluded = ["children", "className", "validationState"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import PropTypes from "prop-types";
import React, { forwardRef } from "react";
import AAlert from "../AAlert";
import "./AHint.scss";
var AHint = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    propsClassName = _ref.className,
    _ref$validationState = _ref.validationState,
    validationState = _ref$validationState === void 0 ? "default" : _ref$validationState,
    rest = _objectWithoutProperties(_ref, _excluded);
  var hasValidationState = validationState !== "default" && !!validationState;
  var className = "a-hint";
  if (propsClassName) {
    className += " ".concat(propsClassName);
  }
  var content = /*#__PURE__*/React.createElement("span", null, children);
  if (hasValidationState) {
    content = /*#__PURE__*/React.createElement(AAlert, {
      level: validationState,
      dismissable: false
    }, children);
  }
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    ref: ref,
    className: className
  }), content);
});
AHint.propTypes = {
  /**
   * Sets the hint content.
   */
  hint: PropTypes.node,
  /**
   * Applies a validation state.
   */
  validationState: PropTypes.oneOf(["default", "warning", "danger"])
};
AHint.displayName = "AHint";
export default AHint;